import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { SAL2110_R01Dto } from './Dto_SAL2110_R01';

export interface SAL2110_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
	itemCd: string;
	itemNm: string;
	refetchListLength?: number;
}

const applyListIndex = (list: SAL2110_R01Dto[]): SAL2110_R01Dto[] =>
	list.map((item, index) => ({
		...item,
		valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
		orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
		orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
	}));

export interface Store_SAL2110_R01 {
	SAL2110_R01Filter: SAL2110_R01Filter;
	SAL2110_R01PastFilter: SAL2110_R01Filter;
	setSAL2110_R01Filter: (filter: Partial<Store_SAL2110_R01['SAL2110_R01Filter']>) => void;
	setSAL2110_R01PastFilter: (filter: Store_SAL2110_R01['SAL2110_R01PastFilter']) => void;

	SAL2110_R01CustomTotalList: SAL2110_R01Dto[];
	setSAL2110_R01CustomTotalList: (list: SAL2110_R01Dto[]) => void;
	SAL2110_R01BrandTotalList: SAL2110_R01Dto[];
	setSAL2110_R01BrandTotalList: (list: SAL2110_R01Dto[]) => void;
	SAL2110_R01ItemTotalList: SAL2110_R01Dto[];
	setSAL2110_R01ItemTotalList: (list: SAL2110_R01Dto[]) => void;

	customTotalColumnState: ColumnState[] | null;
	setCustomTotalColumnState: (state: ColumnState[] | null) => void;
	brandTotalColumnState: ColumnState[] | null;
	setBrandTotalColumnState: (state: ColumnState[] | null) => void;
	itemTotalColumnState: ColumnState[] | null;
	setItemTotalColumnState: (state: ColumnState[] | null) => void;

	customTotalScrollTop: number | null;
	setCustomTotalScrollTop: (top: number | null) => void;
	brandTotalScrollTop: number | null;
	setBrandTotalScrollTop: (top: number | null) => void;
	itemTotalScrollTop: number | null;
	setItemTotalScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultSAL2110_R01Filter: SAL2110_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	itemCd: '',
	itemNm: ''
};

export const useSAL2110_R01Store = create<Store_SAL2110_R01>((set) => ({
	SAL2110_R01Filter: defaultSAL2110_R01Filter,
	SAL2110_R01PastFilter: defaultSAL2110_R01Filter,
	setSAL2110_R01Filter: (update) => set((state) => ({
		SAL2110_R01Filter: {
			...state.SAL2110_R01Filter,
			...update
		}
	})),
	setSAL2110_R01PastFilter: (filter: Store_SAL2110_R01['SAL2110_R01PastFilter']) => set({
		SAL2110_R01PastFilter: filter
	}),

	SAL2110_R01CustomTotalList: [],
	setSAL2110_R01CustomTotalList: (list) => set({ SAL2110_R01CustomTotalList: applyListIndex(list) }),
	SAL2110_R01BrandTotalList: [],
	setSAL2110_R01BrandTotalList: (list) => set({ SAL2110_R01BrandTotalList: applyListIndex(list) }),
	SAL2110_R01ItemTotalList: [],
	setSAL2110_R01ItemTotalList: (list) => set({ SAL2110_R01ItemTotalList: applyListIndex(list) }),

	customTotalColumnState: null,
	setCustomTotalColumnState: (state) => set({ customTotalColumnState: state }),
	brandTotalColumnState: null,
	setBrandTotalColumnState: (state) => set({ brandTotalColumnState: state }),
	itemTotalColumnState: null,
	setItemTotalColumnState: (state) => set({ itemTotalColumnState: state }),

	customTotalScrollTop: null,
	setCustomTotalScrollTop: (top) => set({ customTotalScrollTop: top }),
	brandTotalScrollTop: null,
	setBrandTotalScrollTop: (top) => set({ brandTotalScrollTop: top }),
	itemTotalScrollTop: null,
	setItemTotalScrollTop: (top) => set({ itemTotalScrollTop: top }),

	allCount: 0,
	setAllCount: (allCount) => set({ allCount }),

	initData: () => set({
		SAL2110_R01Filter: defaultSAL2110_R01Filter,
		SAL2110_R01PastFilter: defaultSAL2110_R01Filter,
		SAL2110_R01CustomTotalList: [],
		SAL2110_R01BrandTotalList: [],
		SAL2110_R01ItemTotalList: [],
		customTotalColumnState: null,
		brandTotalColumnState: null,
		itemTotalColumnState: null,
		customTotalScrollTop: null,
		brandTotalScrollTop: null,
		itemTotalScrollTop: null,
		allCount: 0,
	}),
}));
